import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BaseTooltip from '../../Gated/src/components/shared/BaseTooltip';

const ClickTooltip = ({ show, text, arrowDirection, children, style }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <BaseTooltip
      show={show && showTooltip}
      containerProps={{
        onClick: () => {
          setShowTooltip(true);
        },
        style,
      }}
      text={text}
      arrowDirection={arrowDirection}
    >
      {children}
    </BaseTooltip>
  );
};

ClickTooltip.propTypes = {
  show: PropTypes.bool,
  text: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  arrowDirection: PropTypes.oneOf(['right', 'left', 'up', 'down']).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

ClickTooltip.defaultProps = {
  show: false,
  style: null,
};

export default ClickTooltip;
